import { env } from './env';

function normalizeOrigin(url: string): string {
  return url.replace(/\/api\/v1\/?$/, '').replace(/\/$/, '');
}

function isLocalhostHostname(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1';
}

/**
 * Resolve API/Socket origin in production.
 * MatchRoom is served same-origin (nginx → /api, /socket.io). If a bad build baked
 * localhost into VITE_*_URL, use window.location.origin at runtime instead.
 */
export function resolveAppOrigin(explicitUrl?: string): string {
  const explicit = (explicitUrl ?? '').trim();

  if (typeof window !== 'undefined') {
    if (explicit) {
      try {
        const { hostname } = new URL(explicit);
        if (!isLocalhostHostname(hostname)) {
          return normalizeOrigin(explicit);
        }
      } catch {
        // ignore invalid baked URL
      }
    }
    return window.location.origin;
  }

  if (explicit) {
    try {
      const { hostname } = new URL(explicit);
      if (!isLocalhostHostname(hostname)) {
        return normalizeOrigin(explicit);
      }
    } catch {
      // ignore
    }
  }

  return normalizeOrigin(explicit || env.VITE_API_URL || env.VITE_SOCKET_URL || '');
}
